import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";
import { ProviderTag } from "../types";
import { formatProviderTagError } from "../utils/formatProviderTagError";

export async function updateProviderTag(tagId: string, name: string): Promise<ProviderTag> {
  const trimmedName = name.trim();
  const { data, error } = await apiClient
    .from('provider_tags')
    .update({ name: trimmedName })
    .eq('id', tagId)
    .select()
    .single();

  if (error) {
    throw new Error(formatProviderTagError(error, 'Erreur lors de la modification du tag.'));
  }

  return data;
}

export function useUpdateProviderTag() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();
  const spaceId = currentSpace?.id ?? '';

  return useMutation({
    mutationFn: ({ tagId, name }: { tagId: string; name: string }) => updateProviderTag(tagId, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.tags(spaceId) });
      queryClient.invalidateQueries({ queryKey: keys.getProvidersList(spaceId) });
    },
  });
}

